module.exports = __webpack_public_path__ + "img/screenshot-sim-perspective@2x.316d34b2.png";